import { WorkerTransferFlow } from "@/components/roster/WorkerTransferFlow";
import { usePostavke } from "@/lib/postavke";
import type { WorkerOverview } from "@/lib/workerOverview";

/** A missing overview must never be mistaken for an unassigned worker. */
export function WorkerCardTransferFlow({ workerId, workerName, overview, triggerLabel, onDone }: {
  workerId: string;
  workerName?: string;
  overview: WorkerOverview | null;
  triggerLabel?: string;
  onDone: () => void;
}) {
  const { prijelazno } = usePostavke();
  if (!overview || overview.status_radnika.stanje !== "aktivan") return null;
  const current = overview.trenutni_raspored;
  return <div className="space-y-2">
    <WorkerTransferFlow radnikId={workerId} triggerLabel={triggerLabel}
      trenutniRaspored={current ? { ...current, radnik_id: workerId, radnik: workerName ?? null } : null}
      onDone={onDone} />
    {prijelazno && <p className="max-w-sm text-sm">Prijelazno razdoblje: raspored nije blokiran, upozorenja su samo informativna</p>}
  </div>;
}
